export default "/images/vendor/flag-icons/flags/1x1/rs.svg?50976876af74cb64328f2ec6bfa9e9fd";